import React from 'react';
import { Icon, Tooltip } from 'antd';

const Columns = (onDelete) => {
  return [
    {
      title: '',
      key: 'action',
      width: '10%',
      align: 'center',
      render: (text, record) => <Tooltip title="Xóa dòng này"><Icon className='gx-text-danger' onClick={() => onDelete(record.key)} type="delete" /></Tooltip>,
    },
    {
      title: 'Name',
      dataIndex: 'name',
      editable: true,
      width: '90%',
    },
  ];
};

export default Columns;
